import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 2,
  class: "auth-error"
}
const _hoisted_2 = { class: "auth-error__text" }
const _hoisted_3 = {
  key: 0,
  class: "reauth-overlay"
}
const _hoisted_4 = {
  key: 0,
  class: "session-expired-overlay",
  role: "alertdialog",
  "aria-modal": "true",
  "aria-labelledby": "session-expired-text"
}
const _hoisted_5 = { class: "session-expired-overlay__content" }
const _hoisted_6 = {
  id: "session-expired-text",
  class: "session-expired-overlay__text"
}

import {
  ref,
  reactive,
  onMounted,
  onBeforeMount,
  watch,
  nextTick,
  toRefs,
  provide,
  computed,
} from 'vue';
import lodash from 'lodash';
import { useRoute, useRouter } from 'vue-router';
import { isMobile, isIOS, isTablet } from 'mobile-device-detect';
import {
  Alert,
  LotPosition,
  PrintRequest,
  PlatmapInfo,
  Amenity,
  Platmap,
  LotDetails,
  HeaderData,
  PlatmapsInfo,
  NeighborhoodInfo,
  LotDetail,
  NeighborhoodsLots,
  NeighborhoodPlatMap,
  LotInfo,
  QmiDetails,
  FutureHome,
  CommunityFutureHomePlans,
} from './types';
import {
  ModalType,
  LanscapeAlert,
  OrientationType,
  Settings,
  Status,
  UrlFilterList,
  PreAreaNameUrl,
  FutureData,
  SaleLegendStatusOrder,
  LandLegendStatusOrder,
  SESSION_EXPIRED_MESSAGE,
} from './constant';
import {
  apiPrintPDF,
  apiFetchPlatmapInfo,
  apiFetchPlatmapsInfo,
  apiFetchPlatmap,
  apiFetchLots,
  apiFetchPlatmapCordinates,
  apiFetchCommunitiesList,
  apiFetchDivisionsList,
} from './api';
import PlatMapPage from './components/views/PlatMapPage.vue';
import PlatMapModal from './components/modal/PlatMapModal.vue';
import PlatmapAmenityModal from './components/modal/PlatmapAmenityModal.vue';
import ContactInformation from './components/modal/ContactInformation.vue';
import ThankYouModal from './components/modal/ThankYouModal.vue';
import Loader from './components/Loader.vue';
import NotFoundPage from '../src/components/views/404Page.vue';
import PlatMapPrintModal from '../src/components/modal/PlatMapPrintModal.vue';
import { convertToTitleCase } from './core';
import emitter from './mitt';
import { CommunitiesList, CommunityInfo } from './types/communities';
import { DivisionInfo, DivisionsList } from './types/division';
import { useIframeAuth } from './core/useIframeAuth';
import { isParentAppHost, useParentAppToken } from './core/useParentAppToken';
import { useSessionExpiry } from './core/useSessionExpiry';
import http from './core/http';
import { setRequestTypeHeader } from './core/axios-wrapper';

// define props


export default /*@__PURE__*/_defineComponent({
  __name: 'Root',
  props: {
    mode: {},
    showSelectionDropdown: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const { showSelectionDropdown, mode  } = toRefs(props);

// provide
provide('setSelectionDropdown', showSelectionDropdown);
provide('mode', mode);

let $modal!: any;

const route = useRoute();
const router = useRouter();

const platMapPage = ref();
const platMapModal = ref();

const notFound = ref(false);
const selectedLotId = ref('');
const amenityId = ref('');
const showAmenityModal = ref(false);
const selectedHomePlanIds = ref<string[]>([]);
const amenities = ref([] as Amenity[]);
const allAmenities = ref<Array<any>>([]);
const lotPosition = ref({} as LotPosition);
const platmap = ref({} as Platmap);
const lotDetails = ref({} as LotDetails);
const neighborhoodId = ref('');
const selectedNeighborhoodIds = ref<string[]>([]);
const neighborhoods = ref<NeighborhoodInfo[]>([]);
const neighborhoodNames = ref<string[]>([]);
const neighborhoodName = ref('');
const underlay = ref(false);
const legends = ref('');
const areaId = ref('');
const areaName = ref('');
const currentSelectedDivisionId = ref('');
const neighborhoodAreaName = ref('');
const communityDisplayName = ref('');
const communityId = ref('');
const communityName = ref('');
const loading = ref(false);
const SideBarLoader = ref(false);
const printOptionSelected = ref(false);
const alert = ref({} as Alert);
const topPosition = ref(0);
const siblingSelected = ref(false);
const isOpenPrintModal = ref(false);
const isOpenFooter = ref(true);
const centerLatitude = ref(0);
const centerLongitude = ref(0);
const currentNeighborhoodCenterLatitude = ref(0);
const currentNeighborhoodCenterLongitude = ref(0);
const zoomLevel = ref(0);
const hasMobile = !!(isMobile && !isTablet);
const selectQmiData = ref({} as QmiDetails);
const futureHomePlans = ref({} as CommunityFutureHomePlans);
const futureLotIds = ref<string[]>([]);
const showHomeLevel = ref(false);
const actualLevels = ref<string[]>([]);
const activeLevel = ref('');
const showContactInfoModal = ref(false);
const showThankYouModal = ref(false);
const showPlatMapModal = ref(false);
const selectedLotIdInfo = ref<any>({});
const showLotInfoData = ref(false);
let isFetchedData = ref(false);
let communitiesList = ref<CommunityInfo[]>([])
let divisionsList = ref<DivisionInfo[]>([])
// let neighborhoodList = ref([])

provide("communitiesList", communitiesList)
provide("divisionList", divisionsList)

const shouldAuthenticate = computed(() => props.mode === "sales" || props.mode === "land");

if (!shouldAuthenticate.value) {
  setRequestTypeHeader('customer');
} else {
  http.registerRequestInterceptors()
  http.registerResponseInterceptors()
}

const { isAuthenticated, isReauthenticating, error, ready } = !shouldAuthenticate.value
  ? { isAuthenticated: ref(true), isReauthenticating: ref(false), error: ref(null) }
  : isParentAppHost()
    ? useParentAppToken(mode.value)
    : useIframeAuth(mode.value, "platmap");

// A 401 is the only proof the host app's token has gone stale — presence in storage
// is not validity. Broker-hosted deployments keep their own silent re-auth instead.
const { isSessionExpired, redirectNow } = shouldAuthenticate.value && isParentAppHost()
  ? useSessionExpiry()
  : { isSessionExpired: ref(false), redirectNow: () => undefined };

const sessionExpiredButton = ref<HTMLButtonElement | null>(null);

// The notice is the only thing the user can act on once the session is gone, so put
// the caret on its single control rather than leaving it behind the blocked page.
watch(isSessionExpired, async (expired) => {
  if (!expired) return;
  await nextTick();
  sessionExpiredButton.value?.focus();
});

const isAuthPending = computed(() => shouldAuthenticate.value && !isAuthenticated.value);
// Surfaced in place of the loader: without this an auth failure spins forever.
const authError = computed(() => (shouldAuthenticate.value ? error.value : null));

onBeforeMount(async () => {
  await ready;
  const urlNeighborhoodName = route.query[UrlFilterList.NEIGHBORHOOD];
  if (Array.isArray(urlNeighborhoodName)) {
    neighborhoodNames.value.push(urlNeighborhoodName[0]?.toString() ?? '');
  } else if (urlNeighborhoodName) {
    neighborhoodNames.value.push(urlNeighborhoodName as string);
  }

  areaName.value = (route.params.areaName as string) || '';

  if (checkAreaNameFormate()) {
    communityName.value = (route.params.communityName as string) || '';
    fetchPlatmapInfo(
      areaName.value,
      communityName.value,
      neighborhoodNames.value
    );
  } else if(showSelectionDropdown.value) {
    fetchSidebarDropdowns()
  } else {
    loading.value = false;
    // notFound.value = true;
  }

  showHomeLevel.value = false;
  actualLevels.value = [];
  activeLevel.value = '';
});

const fetchSidebarDropdowns = async () => {
  SideBarLoader.value = true;
  const routeDivisionId = route.params.areaCode as string;
  let communityListRequest;
  if(routeDivisionId) {
    currentSelectedDivisionId.value = routeDivisionId
    communityListRequest = getCommunityList(currentSelectedDivisionId.value);
  }

  const divisionsListRequest = apiFetchDivisionsList();

  await Promise.all([communityListRequest, divisionsListRequest]).
  then((responses) => {
    divisionsList.value = responses[1].divisions;
    if(routeDivisionId) {
      selectDivision(divisionsList.value, routeDivisionId);
    }
    SideBarLoader.value = false;
  }).
  catch((err) => {
    SideBarLoader.value = false;
  });
  SideBarLoader.value = false;
}

const selectDivision = (divisionsList: DivisionInfo[], divisionId: string) => {
  const division = divisionsList.find((division) => division.division_code === divisionId);
  if(division) {
    emitter.emit('divisionSelected', {...division});
  }
}

const checkAreaNameFormate = () => {
  if (areaName.value.length > 10) {
    const preAreaName = areaName.value.substring(0, 9);
    const preParts = preAreaName.split('-');
    return (
      `${preParts[0].toLowerCase()}-${preParts[1].toLowerCase()}` ===
      PreAreaNameUrl
    );
  }
  return false;
};
onMounted(() => {
  window.addEventListener('resize', () => {
    platMapPage.value?.recalculateSidebarHeight();
  });
  emitter.on('communityUpdated', updateCommunity);
  emitter.on('newDivisonSelected', fetchCommunityList);
  const neighborhoodCode = route.params.neighborhoodCode as string;
  if(neighborhoodCode) {
    neighborhoodId.value = neighborhoodCode;
    selectedNeighborhoodIds.value = [neighborhoodCode];
   // setTimeout to ensure that the emitter event is called after all parent and child mounted hooks are completed
    setTimeout(() => {
      if(neighborhoodCode) {
        emitter.emit('fetchNeighborhood', true);
      }
    }, 0);
  }
});


const fetchCommunityList = async (selectedDivision: {area: DivisionInfo}) => {
  if(currentSelectedDivisionId?.value !== selectedDivision.area.division_code) {
    currentSelectedDivisionId.value = selectedDivision.area.division_code;
    loading.value = true;
    showThankYouModal.value = false;
    showContactInfoModal.value = false;
    resetCommunityInfo(); 
    await getCommunityList(selectedDivision.area.division_code);
    loading.value=false;
  }
}

const getCommunityList = async (divisonCode: string) => {
  const communitiesListRequest = apiFetchCommunitiesList(divisonCode);
  await communitiesListRequest.
    then((response) => {
      communitiesList.value=response.communities;
    }).
    catch((err) => {
      loading.value=false;
    });
}

function resetCommunityInfo() {
  selectedNeighborhoodIds.value = [];
  communityId.value = "";
  platmap.value = {} as Platmap;
  neighborhoods.value = [];
  selectedHomePlanIds.value = [];
  amenities.value = [];
  allAmenities.value = [];
  lotDetails.value = {} as LotDetails;
  neighborhoodNames.value = [];
  selectQmiData.value = {} as QmiDetails;
  futureHomePlans.value = {} as CommunityFutureHomePlans;
  futureLotIds.value = [];
  actualLevels.value = [];
  lotPosition.value = {} as LotPosition;
  notFound.value = false;
  platMapPage.value?.resetHeaderData();
  closePopups();
}

const closePopups = () => {
  closeAmenityInfo();
  closeLotInfo();
}


const formatCityCommunityNeighborName = (name: string) => {
  const alphabet = [] as string[];
  name.split('').forEach((c) => {
    if (
      (c >= '0' && c <= '9') ||
      (c >= 'A' && c <= 'Z') ||
      (c >= 'a' && c <= 'z') ||
      c == '-' ||
      c == ' ' ||
      c == '/'
    ) {
      alphabet.push(c);
    }
  });
  const changeName = alphabet
    .join('')
    .replaceAll('/', '-')
    .replaceAll(' ', '-')
    .replaceAll('--', '-')
    .replaceAll('--', '-')
    .toLowerCase();
  return changeName;
};

const handleOrientationChange = () => {
  const orientation = isIOS
    ? getIOSOrientation()
    : window.screen.orientation.type;
  const fullHeight = isIOS ? getHeightIOS(orientation) : window.screen.height;
  const fullWidth = isIOS ? getWidthIOS(orientation) : window.screen.width;
  onOrientationChange(fullHeight, fullWidth, orientation);
};

const getIOSOrientation = () => {
  if (
    window.orientation === Settings.IOS_MIN_ORIENTATION ||
    window.orientation === Settings.IOS_MAX_ORIENTATION
  )
    return OrientationType.LANDSCAPE_PRIMARY;
  else return OrientationType.PORTRAIT_PRIMARY;
};

const onOrientationChange = (fullHeight, fullWidth, orientation) => {
  if (
    checkForPortrait(fullHeight, fullWidth, orientation) ||
    checkForLandscape(fullHeight, fullWidth, orientation)
  ) {
    showAlert(LanscapeAlert());
  } else {
    hideAlert();
  }
};

const updateLotInfo = (payload: {
  lotInfo: LotInfo | LotDetail;
  lotId: string;
  isFromModal?: boolean;
}) => {
  const { lotId, lotInfo: lotDetail } = payload;
  if (payload.isFromModal) {
    selectedLotIdInfo.value = payload.lotInfo;
    showLotInfoData.value = true;
  }
  for (const key of Object.keys(futureHomePlans.value)) {
    const isFutureHomePlans = futureHomePlans.value[key].find(
      (element) => element.job_number === lotId
    );
    if (isFutureHomePlans) {
      if ('lot' in lotDetail) {
        lotDetail.lot.color = mode.value === 'customer' ? '#CBBE98' : '#C9BE9C';
        lotDetail.lot.status = Status.FUTURE_HOME;
      } else {
        lotDetail.color = mode.value === 'customer' ? '#CBBE98' : '#C9BE9C';
        lotDetail.status = Status.FUTURE_HOME;
      }
    }
  }
};

const checkForPortrait = (fullHeight, fullWidth, orientation) => {
  return (
    (orientation === OrientationType.PORTRAIT_PRIMARY &&
      !isTablet &&
      (fullHeight < Settings.PORTRAIT_MIN_HEIGHT ||
        fullWidth > Settings.PORTRAIT_MAX_WIDTH)) ||
    (isTablet && fullWidth < Settings.TABLET_PORTRAIT_MIN_WIDTH)
  );
};

const checkForLandscape = (fullHeight, fullWidth, orientation) => {
  return (
    orientation === OrientationType.LANDSCAPE_PRIMARY &&
    (fullHeight < Settings.LANDSCAPE_MAX_HEIGHT ||
      fullWidth < Settings.LANDSCAPE_MIN_WIDTH)
  );
};

const getHeightIOS = (orientation) => {
  if (orientation === OrientationType.LANDSCAPE_PRIMARY)
    return window.screen.width;
  else return window.screen.height;
};

const getWidthIOS = (orientation) => {
  if (orientation === OrientationType.LANDSCAPE_PRIMARY)
    return window.screen.height;
  else return window.screen.width;
};

const showAlert = (alertObj: Alert) => {
  alert.value = alertObj;
  hideLoader();
};

const hideAlert = () => {
  alert.value = {} as Alert;
  closeModal(ModalType.ALERT);
};

const openModal = (modalName: string) => {
  // $modal?.show(modalName);
  toggleModal(modalName, true);
};

const toggleModal = (modalName: string, value: boolean) => {
  switch (modalName) {
    case ModalType.CONTACT_INFO:
      showContactInfoModal.value = !!value;
      break;

    case ModalType.THANK_YOU:
      showThankYouModal.value = !!value;
      break;

    case ModalType.CROPPING_TOOL:
      showPlatMapModal.value = !!value;
      break;
  }
};

const closeModal = (modalName: string) => {
  if (modalName === ModalType.CROPPING_TOOL) {
    setPrintModal(false);
  }
  // $modal?.hide(modalName);
  toggleModal(modalName, false);
};

const setZoomLevelMapPage = (level: number) => {
  zoomLevel.value = level;
};

const calculateContactInfoTopPosition = () => {
  const outerHeight =
    isMobile && !isTablet
      ? Settings.TOP_OUTER_HEIGHT_MOBILE
      : Settings.TOP_OUTER_HEIGHT_TABLET;
  const header = document.getElementById('header') as HTMLElement;
  topPosition.value =
    (header && header.clientHeight
      ? header.clientHeight
      : Settings.TOP_OUTER_HEIGHT_TABLET) + outerHeight;
};

const setLotId = (lotInfo: {
  lotId: string;
  homeplanIds: string[];
  lotPosition: any;
}) => {
  selectedLotId.value = lotInfo.lotId;
  selectedHomePlanIds.value = lotInfo.homeplanIds;
  lotPosition.value = lotInfo.lotPosition;
};

watch(selectedLotId, (newVal) => {
  if (!newVal) {
    selectedLotIdInfo.value = {};
    showLotInfoData.value = false;
  }
});

const setselectQmiData = (selectedQmiData: QmiDetails) => {
  selectQmiData.value = selectedQmiData;
};
const setAminityId = (amId: string, lotPos?: LotPosition) => {
  amenityId.value = amId;
  nextTick(() => {
    showAmenityModal.value = true;

    if (lotPosition.value) {
      lotPosition.value = lotPos as LotPosition;
    }
  });
  if (isTablet) {
    const { hideFooter, hideHeader } = platMapPage.value;
    hideFooter();
    hideHeader();
  }
};

const handlePrintSelectionClick = (payload: {
  printOptionSelected: boolean;
  showHomeLevel: boolean;
  actualLevels: any;
  selectedLevel: string;
}) => {
  printOptionSelected.value = payload.printOptionSelected;
  showHomeLevel.value = payload.showHomeLevel;
  actualLevels.value = payload.actualLevels;
  activeLevel.value = payload.selectedLevel;
};
const openPrintModal = () => {
  const { handlePrintClick } = platMapPage.value;
  handlePrintClick();
};

const loadNeighborhood = (payload: {
  areaNameVal: string;
  communityNameVal: string;
  neighborhoodNameVal: string;
}) => {
  const { areaNameVal, communityNameVal, neighborhoodNameVal } = payload;
  neighborhoodId.value = '';
  neighborhoodName.value = neighborhoodNameVal;
  areaName.value = areaNameVal;
  communityName.value = communityNameVal;
  siblingSelected.value = true;

  closeAmenityInfo();
  handleCloseLotInfo();

  const query = route.query.kiosk ? { kiosk: route.query.kiosk } : {};

  router.replace({
    path: `/custom-homes/${areaNameVal}/community/${communityNameVal}/${neighborhoodNameVal}/plat`,
    query,
  });

  // fetchPlatmapInfo(areaName.value, communityName.value, neighborhoodName.value)
};

const clearSelectedNeighborhoods = () => {
  selectedNeighborhoodIds.value = [];
};

const selectNeighborhood = (neighborhoodId: string) => {
  if (selectedNeighborhoodIds.value.includes(neighborhoodId)) {
    clearSelectedNeighborhoods();
  } else {
    selectedNeighborhoodIds.value = [neighborhoodId];
    [
      currentNeighborhoodCenterLatitude.value,
      currentNeighborhoodCenterLongitude.value,
    ] = getCurrentNeighborhoodPosition();
  }
};
const removeMobileHomeTypeFilter = () => {
  const planNameList = platMapPage.value?.listPlanNameMobileFilter;
  const qmiList = platMapPage.value?.qmiFilterListMobileFilter;
  platMapPage.value?.applyMobileFilters({
    listPlanName: planNameList,
    listHomeType: [],
    qmiFilterList: qmiList,
  });
};
const setHomeTypeCount = (homeTypeCount: number) => {
  if (homeTypeCount < 2) {
    const planNameList = platMapPage.value?.filterPlanNameList;
    const maxPrice = platMapPage.value?.filterMaxPrice;
    const minPrice = platMapPage.value?.filterMinPrice;
    platMapPage.value?.setFilterProperties({
      listHomeType: [],
      listPlanName: planNameList,
      maxPrice,
      minPrice,
    });
    if (hasMobile) {
      removeMobileHomeTypeFilter();
    }
  }
};

const updateQmiAddressInUrl = () => {
  if (!Object.keys(selectQmiData.value).length) {
    const newQuery = { ...route.query };
    newQuery[UrlFilterList.LOT] = [];
    router.push({ query: newQuery }).catch(() => {});
  }
};

const setNeighborhoodName = (nbName: string) => {
  neighborhoodName.value = nbName;
};

const setNeighborhoodAreaName = (val: string) => {
  neighborhoodAreaName.value = val;
};

const setCommunityName = (val: string) => {
  communityDisplayName.value = val;
};

const setLegends = (val: string) => {
  legends.value = val;
};

const setAmenities = (val: any) => {
  amenities.value = val;
};

const setUnderlay = (val: boolean) => {
  underlay.value = val;
};

const setMapCenter = (x: number, y: number) => {
  platMapPage.value?.setMapCenter(x, y);
};

const setAllAmenities = (amenities: Array<Amenity>) => {
  allAmenities.value = amenities;
};

const closeLotInfo = () => {
  selectedLotId.value = '';
  selectedHomePlanIds.value = [];
  lotPosition.value = {} as LotPosition;
  if (isMobile && isTablet) {
    const { showHeader, toolbar } = platMapPage.value;
    // showFooter();
    // showSidebar();
    if (!toolbar.value) showHeader();
  }
  updateQmiAddressInUrl();
};
const handleCloseLotInfo = () => {
  if (platMapModal.value) {
    const { beforeClose } = platMapModal.value;
    beforeClose();
  } else closeLotInfo();
};

const closeAmenityInfo = () => {
  if (amenityId.value && isTablet) {
    const { showHeader, showFooter, showSidebar } = platMapPage.value;
    showHeader();
    showFooter();
    showSidebar();
  }
  amenityId.value = '';
  showAmenityModal.value = false;
  if (isMobile) {
    const { showHeader, toolbar } = platMapPage.value;
    if (!toolbar) showHeader();
  }
};

const updateLotPosition = (lotPos) => {
  lotPosition.value = {...lotPos};
};

const showLoader = () => {
  loading.value = true;
};
const hideLoader = () => {
  loading.value = false;
};

const isPlatMapValid = () => {
  return (
    platmap.value.url &&
    platmap.value.svg_html &&
    platmap.value.display_status === 'active'
  );
};

const printPDF = async (platmap: string) => {
  try {
    let currentPDFTitle = communityName.value;
    if (selectedNeighborhoodIds.value.length) {
      const currentNeighborhood = neighborhoods.value.filter(
        (element) =>
          element.neighborhood_code === selectedNeighborhoodIds.value[0]
      );
      currentPDFTitle = currentNeighborhood[0].neighborhood_name;
    }

    const legends = 'Available,Quick Move-In,Future Home,Sold,Model';

    const printRequest: PrintRequest = {
      areaId: areaId.value,
      legend: amenities.value.length ? legends.concat(',', 'Amenity') : legends,
      neighborhoodName: communityDisplayName.value,
      platMap: platmap,
      mode: mode.value,
      printTime: '',
    };
    if (mode.value === 'sales') {
      printRequest.legend = SaleLegendStatusOrder.join(',');
    } else if (mode.value === 'land') {
      printRequest.legend = LandLegendStatusOrder.join(',');
    }

    closeModal(ModalType.CROPPING_TOOL);
    apiPrintPDF(printRequest);
    openModal(ModalType.THANK_YOU);
  } catch (error) {
    loading.value = false;
  }
};

const addCityStateTitle = (state: string, city: string) => {
  const cName = convertToTitleCase(`${communityName.value}`);

  if (state && city) {
    state = state.toUpperCase();
    city = convertToTitleCase(`${city}`);
    const location = `${city}, ${state}`;

    const newTitle = `Explore a Plat Map of ${cName} - ${location}`;
    const metaDescription = `Explore neighborhoods and lots in ${cName}, ${location}. See available lots, homes under construction and amenities on a map`;

    document.title = newTitle;
    const element = document.head.querySelector('meta[name="description"]');
    if (element instanceof HTMLMetaElement) {
      element.content = metaDescription;
    }
  }
};

const fetchPlatmapInfo = async (
  areaNameVal: string,
  communityNameVal: string,
  neighborhoodNames: string[]
) => {
  try {
    loading.value = true;
    // neighborhoods.value = [];
    // selectedNeighborhoodIds.value = [];
    const responses = await apiFetchPlatmapsInfo(areaNameVal, communityNameVal);
    const platMapsInfo = responses.result as PlatmapsInfo;

    platMapsInfo.city = formatCityCommunityNeighborName(platMapsInfo.city);
    platMapsInfo.state = formatCityCommunityNeighborName(platMapsInfo.state);

    areaId.value = platMapsInfo.area_id;
    communityId.value = platMapsInfo.community_code;
    neighborhoods.value = platMapsInfo.neighborhoods;

    neighborhoods.value.forEach((neighbor) => {
      neighbor.neighborhood_name = formatCityCommunityNeighborName(
        neighbor.neighborhood_name
      );
    });

    addCityStateTitle(platMapsInfo.state, platMapsInfo.city);

    neighborhoods.value.forEach((neighborhood) => {
      if (neighborhoodNames.includes(neighborhood.neighborhood_name) || neighborhoodId.value === neighborhood.neighborhood_code) {
        selectedNeighborhoodIds.value.push(neighborhood.neighborhood_code);
      }
    });

    if (!selectedNeighborhoodIds.value.length) {
      const newQuery = { ...route.query };
      newQuery[UrlFilterList.NEIGHBORHOOD] = [];
      router.push({ query: newQuery }).catch(() => {});
    }
  } catch (error) {
    loading.value = false;
    notFound.value = true;
  }
};

const getFutureLotIds = () => {
  Object.values(futureHomePlans.value).forEach((plans: any[]) => {
    const ids = plans.map((plan) => plan.job_number);
    futureLotIds.value.push(...ids);
  });
};

const getCurrentNeighborhoodPosition = () => {
  let currentNeighborhoodLatitude = 0;
  let currentNeighborhoodLongitude = 0;
  const currentNeighborhoodData = platmap.value.neighborhoods.find(
    (neighborhood) => neighborhood.id === selectedNeighborhoodIds.value[0]
  );
  if (currentNeighborhoodData) {
    currentNeighborhoodLatitude = currentNeighborhoodData?.latitude;
    currentNeighborhoodLongitude = currentNeighborhoodData?.longitude;
  } else {
    const firstNeighborhood = platmap.value.neighborhoods[0];
    currentNeighborhoodLatitude = firstNeighborhood.latitude;
    currentNeighborhoodLongitude = firstNeighborhood.longitude;
  }
  return [currentNeighborhoodLatitude, currentNeighborhoodLongitude];
};

const fetchFutureHomePlans = (neighborhoods: NeighborhoodsLots) => {
  const neighborhoodFuturePlan = [] as FutureHome[];
  neighborhoods.lots.forEach((lot) => {
    if (lot.isFuturePlan || lot.status.toLowerCase() === 'future home') {
      neighborhoodFuturePlan.push({
        elevation: lot.elevation,
        address: lot.address,
        plan_name: lot.plan_name,
        job_number: lot.id,
        color: lot.color || '#CBBE98'
      });
    }
  });
  if (neighborhoodFuturePlan.length)
    futureHomePlans.value[neighborhoods.neighborhood_code] =
      neighborhoodFuturePlan;
};
const fetchPlatmap = async (payload: {
  neighborhoodId: string;
  communityCode: string;
  header: HeaderData;
}) => {
  try {
    futureHomePlans.value = {} as CommunityFutureHomePlans;
    const resPlatmap = await apiFetchPlatmap(
      payload.neighborhoodId,
      payload.communityCode
    );
    platmap.value = resPlatmap.result as Platmap;

    if (isPlatMapValid()) {
      // fetch all lots in neighborhoods
      const promises = neighborhoods.value.map((neighborhood) =>
        apiFetchLots(
          neighborhood.neighborhood_code,
          platmap.value.neighborhoods.find(
            (nb) => nb.id === neighborhood.neighborhood_code
          )?.nb_unit_type || '',
          mode.value
        )
      );

      const responses = await Promise.all(
        promises.map((promise) => promise.catch((error) => error))
      );

      const nbhLots: NeighborhoodsLots[] = [];
      responses.forEach((response, idx) => {
        if (response.result) {
          const neighborhoodLots: NeighborhoodsLots = {
            neighborhood_code: neighborhoods.value[idx].neighborhood_code,
            lots: response.result.lots as LotDetail[],
          };
          nbhLots.push(neighborhoodLots);
          fetchFutureHomePlans(neighborhoodLots);
        }
      });

      // update future lot IDs
      getFutureLotIds();

      // update lot details
      lotDetails.value.neighborhoods = nbhLots;

      const activeNeighborhood = responses.filter((r) => !!r.result);
      if (activeNeighborhood.length) {
        lotDetails.value.amenity = activeNeighborhood[0].result
          .amenity as Amenity[];
        setAllAmenities(activeNeighborhood[0].result.amenity as Amenity[]);
      }

      setUnderlay(platmap.value.underlay_on);
      centerLatitude.value = platmap.value.center_latitude;
      centerLongitude.value = platmap.value.center_longitude;

      const [lat, lng] = getCurrentNeighborhoodPosition();
      currentNeighborhoodCenterLatitude.value = lat;
      currentNeighborhoodCenterLongitude.value = lng;
      isFetchedData.value = true;
    } else {
      notFound.value = true;
    }

    hideLoader();
  } catch (error) {
    platmap.value = {} as Platmap;
    lotDetails.value = {} as any;
    hideLoader();
    notFound.value = true;
  }
};

const showPlanFutureLotFlyout = (payload: {
  lotInfo: LotInfo;
  lotId: string;
}) => {
  const futurePlan: FutureHome[] = [];

  if (
    Object.keys(payload.lotInfo).length &&
    futureLotIds.value.includes(payload.lotId)
  ) {
    Object.values(futureHomePlans.value).forEach((planArr) =>
      futurePlan.push(...planArr)
    );

    const showPlanOnFlyout = futurePlan.find(
      (plan) => plan.job_number === payload.lotId
    );

    const planData = payload.lotInfo.homes_plans.find(
      (plan) =>
        plan.name.toLowerCase() === showPlanOnFlyout?.plan_name.toLowerCase()
    );

    if (planData) {
      planData[FutureData.ELEVATION] = showPlanOnFlyout?.elevation;
      payload.lotInfo.homes_plans = [planData];
    }
  }
};
const fetchPlatmapCoordinates = async (nId: string, header: HeaderData) => {
  try {
    const res = await apiFetchPlatmapCordinates(nId);
    platmap.value = res.result as Platmap;

    if (isPlatMapValid()) {
      const resLots = await apiFetchLots(neighborhoodId.value, '', mode.value);
      lotDetails.value = resLots.result as LotDetails;

      setAllAmenities(lotDetails.value.amenity);
      setUnderlay(platmap.value.underlay_on);
    } else {
      notFound.value = true;
    }

    hideLoader();
  } catch (error) {
    platmap.value = {} as Platmap;
    lotDetails.value = {} as LotDetails;
    hideLoader();
    notFound.value = true;
  }
};
const setPrintModal = (value: boolean) => {
  isOpenPrintModal.value = value;
};
const isKioskMode = () => {
  return !(!route.query.kiosk || route.query.kiosk === 'false');
};
const setFooterState = (value: boolean) => {
  isOpenFooter.value = value;
};

const updateCommunity = (payload: {area: DivisionInfo, community: CommunityInfo  }) => {
  isFetchedData.value = false;
  showThankYouModal.value = false;
  showContactInfoModal.value = false;
  const area = payload.area.area_link_name;
  areaName.value = area;
  communityName.value = payload.community.cmu_link_name || '';
  selectedNeighborhoodIds.value = [];
  closePopups();
  fetchPlatmapInfo(
    areaName.value,
    communityName.value,
    neighborhoodNames.value
  );
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", {
    class: _normalizeClass(['dreesWrapper', { 'chaticon-toggle': !isOpenFooter.value }, {'sales-view': _unref(showSelectionDropdown)}])
  }, [
    _createVNode(PlatMapPage, {
      ref_key: "platMapPage",
      ref: platMapPage,
      areaName: areaName.value,
      areaId: areaId.value,
      communityName: communityName.value.replace('_', ' '),
      isFetchedData: _unref(isFetchedData),
      neighborhoodId: neighborhoodId.value,
      selectedNeighborhoodIds: selectedNeighborhoodIds.value,
      neighborhoods: neighborhoods.value,
      communityId: communityId.value,
      loading: loading.value,
      selectedLotId: selectedLotId.value,
      selectedHomePlanIds: selectedHomePlanIds.value,
      platmap: platmap.value,
      lotDetails: lotDetails.value,
      siblingSelected: siblingSelected.value,
      amenities: amenities.value,
      selectedNeighborhoodCenterLatitude: currentNeighborhoodCenterLatitude.value,
      selectedNeighborhoodCenterLongitude: currentNeighborhoodCenterLongitude.value,
      isKioskMode: isKioskMode(),
      futureHomePlans: futureHomePlans.value,
      showLotInfoData: showLotInfoData.value,
      selectedLotIdInfo: selectedLotIdInfo.value,
      onShowPlanFutureLotFlyout: showPlanFutureLotFlyout,
      onSetNeighborhoodAreaName: setNeighborhoodAreaName,
      onSetCommunityName: setCommunityName,
      onFetchPlatmapCoordinates: fetchPlatmapCoordinates,
      onFetchPlatmap: fetchPlatmap,
      onSetAllAmenities: setAllAmenities,
      onPrintPDF: printPDF,
      onSetUnderlay: setUnderlay,
      onSetAmenities: setAmenities,
      onSetLegends: setLegends,
      onHandlePrintSelectionClick: handlePrintSelectionClick,
      onCloseAmenityInfo: closeAmenityInfo,
      onCloseLotInfo: closeLotInfo,
      onHandleCloseLotInfo: handleCloseLotInfo,
      onOpenModal: openModal,
      onCloseModal: closeModal,
      onSetLotId: setLotId,
      onSetAminityId: setAminityId,
      onShowLoader: showLoader,
      onHideLoader: hideLoader,
      onSelectNeighborhood: selectNeighborhood,
      onLoadNeighborhood: loadNeighborhood,
      onSetNeighborhoodName: setNeighborhoodName,
      onNotFound: _cache[0] || (_cache[0] = ($event: any) => (notFound.value = true)),
      onCalculateContactInfoTopPosition: calculateContactInfoTopPosition,
      onSetPrintModal: setPrintModal,
      onUpdateChatBotPosition: setFooterState,
      onClearSelectedNeighborhoods: clearSelectedNeighborhoods,
      onSetZoomLevelMapPage: setZoomLevelMapPage,
      onUpdateLotInfo: updateLotInfo,
      onSetHomeTypeCount: setHomeTypeCount,
      onSetselectQmiData: setselectQmiData
    }, null, 8, ["areaName", "areaId", "communityName", "isFetchedData", "neighborhoodId", "selectedNeighborhoodIds", "neighborhoods", "communityId", "loading", "selectedLotId", "selectedHomePlanIds", "platmap", "lotDetails", "siblingSelected", "amenities", "selectedNeighborhoodCenterLatitude", "selectedNeighborhoodCenterLongitude", "isKioskMode", "futureHomePlans", "showLotInfoData", "selectedLotIdInfo"]),
    (notFound.value)
      ? (_openBlock(), _createBlock(NotFoundPage, { key: 0 }))
      : _createCommentVNode("", true),
    (showContactInfoModal.value)
      ? (_openBlock(), _createBlock(ContactInformation, {
          key: 1,
          showModal: showContactInfoModal.value,
          printOptionSelected: printOptionSelected.value,
          areaId: areaId.value,
          neighborhoodAreaName: neighborhoodAreaName.value,
          neighborhoodName: neighborhoodName.value,
          neighborhoodId: neighborhoodId.value,
          topPosition: topPosition.value,
          legends: legends.value,
          onOpenPrintModal: openPrintModal,
          onCloseModal: closeModal,
          onOpenModal: openModal
        }, null, 8, ["showModal", "printOptionSelected", "areaId", "neighborhoodAreaName", "neighborhoodName", "neighborhoodId", "topPosition", "legends"]))
      : _createCommentVNode("", true),
    _createVNode(PlatMapPrintModal, {
      showModal: showPlatMapModal.value,
      isOpenPrintModal: isOpenPrintModal.value,
      underlay_on: platmap.value.underlay_on,
      showHomeLevel: showHomeLevel.value,
      actualLevels: actualLevels.value,
      activeLevel: activeLevel.value,
      onCloseModal: closeModal,
      onPrintPDF: printPDF
    }, null, 8, ["showModal", "isOpenPrintModal", "underlay_on", "showHomeLevel", "actualLevels", "activeLevel"]),
    _createVNode(ThankYouModal, {
      showModal: showThankYouModal.value,
      mode: _unref(mode),
      onCloseModal: closeModal,
      topPosition: topPosition.value,
      printOptionSelected: printOptionSelected.value
    }, null, 8, ["showModal", "mode", "topPosition", "printOptionSelected"]),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (showAmenityModal.value && !!amenityId.value)
          ? (_openBlock(), _createBlock(PlatmapAmenityModal, {
              key: 0,
              amenityId: amenityId.value,
              position: lotPosition.value,
              underlay: underlay.value,
              amenities: amenities.value,
              allAmenities: allAmenities.value,
              isKioskMode: isKioskMode(),
              zoomLevel: zoomLevel.value,
              onSetMapCenter: setMapCenter,
              onSetAminityId: setAminityId,
              onUpdateLotPosition: updateLotPosition,
              onCloseAmenityInfo: closeAmenityInfo
            }, null, 8, ["amenityId", "position", "underlay", "amenities", "allAmenities", "isKioskMode", "zoomLevel"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (!!selectedLotId.value)
          ? (_openBlock(), _createBlock(PlatMapModal, {
              key: 0,
              ref_key: "platMapModal",
              ref: platMapModal,
              lotId: selectedLotId.value,
              position: lotPosition.value,
              neighborhoods: neighborhoods.value,
              selectedNeighborhoodIds: selectedNeighborhoodIds.value,
              zoomLevel: zoomLevel.value,
              isKioskMode: isKioskMode(),
              underlay: platmap.value.underlay_on,
              onShowPlanFutureLotFlyout: showPlanFutureLotFlyout,
              onCalculateContactInfoTopPosition: calculateContactInfoTopPosition,
              onHandlePrintSelectionClick: handlePrintSelectionClick,
              onUpdateLotPosition: updateLotPosition,
              onCloseLotInfo: closeLotInfo,
              onOpenModal: openModal,
              onUpdateLotInfo: updateLotInfo
            }, null, 8, ["lotId", "position", "neighborhoods", "selectedNeighborhoodIds", "zoomLevel", "isKioskMode", "underlay"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (authError.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("p", _hoisted_2, _toDisplayString(authError.value), 1)
        ]))
      : (loading.value || isAuthPending.value)
        ? (_openBlock(), _createBlock(Loader, { key: 3 }))
        : _createCommentVNode("", true),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (_unref(isReauthenticating))
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [...(_cache[2] || (_cache[2] = [
              _createElementVNode("div", { class: "reauth-overlay__content" }, [
                _createElementVNode("span", { class: "reauth-overlay__spinner" }),
                _createElementVNode("span", { class: "reauth-overlay__text" }, "Reconnecting…")
              ], -1)
            ]))]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (_unref(isSessionExpired))
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(SESSION_EXPIRED_MESSAGE)), 1),
                _createElementVNode("button", {
                  ref_key: "sessionExpiredButton",
                  ref: sessionExpiredButton,
                  type: "button",
                  class: "session-expired-overlay__button",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(redirectNow) && _unref(redirectNow)(...args)))
                }, " OK ", 512)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 2))
}
}

})